import { CovidMessageBanner } from './covid';

export const bannerComponents = {
  covid: CovidMessageBanner,
};
